import { createReducer } from "../../util/reducerUtil";
import { SELECTED_CATEGORY, SELECTED_TEST } from "./selectConstants";

const initialState = {
    selectedCategory: "CategoryTests",
    selectedTest: ""
};

export const selectCategory = (state, payload) => {
    return { ...state, selectedCategory: payload };
};

export const selectTest = (state, payload) => {
    return { ...state, selectedTest: payload };
};

export default createReducer(initialState, {
    [SELECTED_CATEGORY]: selectCategory,
    [SELECTED_TEST]: selectTest
});
